import {useEffect, useRef} from "react";

import {IRange} from "@pg-design/inputs-module";
import {RequestState} from "@pg-mono/request-state";

import {trackAmplitudePropertyViewItemList} from "../../tracking/amplitude/track_amplitude_property_view_item_list";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";
import {IPropertyListProperty} from "../types/PropertyListProperty";

interface IRoomsFilterLabel {
    slug: string;
    text: string;
}

const getRoomsFilterLabel = (rooms: IRange<number | "">): IRoomsFilterLabel => {
    const value = rooms.lower !== "" ? rooms.lower : rooms.upper;

    if (value === "" || value == null) {
        return {slug: "all", text: "wszystkie"};
    }

    if (value >= 5) {
        return {slug: "5_plus", text: "5 pokoi i więcej"};
    }

    return {slug: String(value), text: value === 1 ? "1 pokój" : `${value} pokoje`};
};

interface IUseOtherPropertiesInOfferAmplitudeViewItemListTrackingParams {
    offer: IPropertyDetailOffer;
    properties: IPropertyListProperty[];
    rooms: IRange<number | "">;
    listName: string;
    requestState: RequestState;
    isWaitingForElement?: boolean;
}

export const useOtherPropertiesInOfferAmplitudeViewItemListTracking = ({
    offer,
    properties,
    rooms,
    listName,
    requestState,
    isWaitingForElement = false
}: IUseOtherPropertiesInOfferAmplitudeViewItemListTrackingParams) => {
    const roomsFilterLabel = getRoomsFilterLabel(rooms);
    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offer.id}|${roomsFilterLabel.slug}|${propertyIdsKey}`;

    const contextRef = useRef<{key: string; itemListId: string} | null>(null);

    if (contextRef.current?.key !== contextKey) {
        contextRef.current = {
            key: contextKey,
            itemListId: `${Math.floor(Date.now() / 1000)}_other_properties_${offer.id}_${roomsFilterLabel.slug}`
        };
    }

    const itemListId = contextRef.current.itemListId;
    const itemListName = `${listName} - ${roomsFilterLabel.text}`;

    const prevTrackedItemListIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (isWaitingForElement || requestState !== RequestState.Success || properties.length === 0) {
            return;
        }

        if (prevTrackedItemListIdRef.current === itemListId) {
            return;
        }

        prevTrackedItemListIdRef.current = itemListId;

        trackAmplitudePropertyViewItemList({offer, properties, itemListId, itemListName});
    }, [isWaitingForElement, requestState, itemListId, properties, offer, itemListName]);

    return {itemListId, itemListName};
};
import {useEffect, useRef} from "react";

import {IRange} from "@pg-design/inputs-module";
import {RequestState} from "@pg-mono/request-state";

import {trackAmplitudePropertyViewItemList} from "../../tracking/amplitude/track_amplitude_property_view_item_list";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";
import {IPropertyListProperty} from "../types/PropertyListProperty";

interface IRoomsFilterLabel {
    slug: string;
    text: string;
}

const getRoomsFilterLabel = (rooms: IRange<number | "">): IRoomsFilterLabel => {
    const value = rooms.lower !== "" ? rooms.lower : rooms.upper;

    if (value === "" || value == null) {
        return {slug: "all", text: "wszystkie"};
    }

    if (value >= 5) {
        return {slug: "5_plus", text: "5 pokoi i więcej"};
    }

    return {slug: String(value), text: value === 1 ? "1 pokój" : `${value} pokoje`};
};

interface IUseOtherPropertiesInOfferAmplitudeViewItemListTrackingParams {
    offer: IPropertyDetailOffer;
    properties: IPropertyListProperty[];
    rooms: IRange<number | "">;
    listName: string;
    requestState: RequestState;
    isWaitingForElement?: boolean;
}

export const useOtherPropertiesInOfferAmplitudeViewItemListTracking = ({
    offer,
    properties,
    rooms,
    listName,
    requestState,
    isWaitingForElement = false
}: IUseOtherPropertiesInOfferAmplitudeViewItemListTrackingParams) => {
    const roomsFilterLabel = getRoomsFilterLabel(rooms);
    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offer.id}|${roomsFilterLabel.slug}|${propertyIdsKey}`;

    const contextRef = useRef<{key: string; itemListId: string} | null>(null);

    if (contextRef.current?.key !== contextKey) {
        contextRef.current = {
            key: contextKey,
            itemListId: `${Math.floor(Date.now() / 1000)}_other_properties_${offer.id}_${roomsFilterLabel.slug}`
        };
    }

    const itemListId = contextRef.current.itemListId;
    const itemListName = `${listName} - ${roomsFilterLabel.text}`;

    const prevTrackedItemListIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (isWaitingForElement || requestState !== RequestState.Success || properties.length === 0) {
            return;
        }

        if (prevTrackedItemListIdRef.current === itemListId) {
            return;
        }

        prevTrackedItemListIdRef.current = itemListId;

        trackAmplitudePropertyViewItemList({offer, properties, itemListId, itemListName});
    }, [isWaitingForElement, requestState, itemListId, properties, offer, itemListName]);

    return {itemListId, itemListName};
};
